import axios from 'axios'
import * as auth_util from '../utils/auth_util.js'
import { HBNS_APP_ID, CONFIG_SERVER_ENDPOINT, CONFIG_SERVER_APIKEY } from '../utils/appconfig.js'
import { generateTraceId } from '../utils/service_util.js'



export const fetch_dynamic_config = async (config_name, onComplete, onError) => {
  // await delay(1000); // simulate network delay for testing loading states
  const headers = {
    'HBNS-APP-ID': HBNS_APP_ID,
    'HBNS-TRACE-ID': generateTraceId(),
    'HBNS-APIKEY': CONFIG_SERVER_APIKEY
  }
  // const api_url = `https://configure.api-dev.huntercbuxton.com/configserver/${config_name}`
  const api_url = `${CONFIG_SERVER_ENDPOINT}/configserver/${config_name}`
  try {
    const response = await axios.post(api_url, {}, { headers })
    onComplete(response.data)
  } catch (err) {
    onError(err)
  }
}
